import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import config from '../../config';
import * as XLSX from 'xlsx';

const company = JSON.parse(sessionStorage.getItem('companyDetails'));

const token = () => sessionStorage.getItem('token');
const getUserDetails = () =>
  JSON.parse(sessionStorage.getItem('userDetails') || '{}');

// ─── Tiny icon components ─────────────────────────────────────────────────────
const Icon = ({ d, size = 16, ...p }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={1.8}
    strokeLinecap='round'
    strokeLinejoin='round'
    {...p}>
    <path d={d} />
  </svg>
);

const icons = {
  wallet:
    'M21 12V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2M16 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4z',
  search: 'M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z',
  download: 'M12 3v14M5 17l7 4 7-4',
  eye: 'M1 12S5 5 12 5s11 7 11 7-4 7-11 7S1 12 1 12zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z',
  close: 'M18 6 6 18M6 6l12 12',
  plus: 'M12 5v14M5 12h14',
  minus: 'M5 12h14',
  chevron: 'M6 9l6 6 6-6',
  users:
    'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75',
};

// ─── Styles ───────────────────────────────────────────────────────────────────
const styles = {
  page: {
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
    background: '#F7F8FA',
    minHeight: '100vh',
    padding: '0',
  },

  // Top bar
  topbar: {
    background: '#fff',
    borderBottom: '1px solid #EAECF0',
    padding: '14px 28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  },
  topbarTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    fontSize: 17,
    fontWeight: 700,
    color: '#0F172A',
    letterSpacing: '-0.3px',
  },
  topbarBadge: {
    fontSize: 11,
    fontWeight: 600,
    background: '#EFF6FF',
    color: '#2563EB',
    padding: '3px 8px',
    borderRadius: 20,
    border: '1px solid #BFDBFE',
  },

  // Content
  content: { padding: '20px 28px 40px' },

  // Stat strip
  statStrip: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))',
    gap: 12,
    marginBottom: 20,
  },
  statCard: {
    background: '#fff',
    border: '1px solid #EAECF0',
    borderRadius: 10,
    padding: '14px 18px',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  statIcon: (bg, fg) => ({
    width: 36,
    height: 36,
    borderRadius: 8,
    background: bg,
    color: fg,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  }),
  statLabel: {
    fontSize: 11,
    color: '#6B7280',
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: 2,
  },
  statValue: { fontSize: 20, fontWeight: 700, color: '#0F172A', lineHeight: 1 },
  statSub: { fontSize: 11, color: '#9CA3AF', marginTop: 2 },

  // Toolbar
  toolbar: {
    display: 'flex',
    gap: 8,
    marginBottom: 14,
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  searchGroup: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  searchBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    background: '#fff',
    border: '1px solid #EAECF0',
    borderRadius: 8,
    padding: '7px 12px',
    fontSize: 13,
    color: '#374151',
  },
  searchInput: {
    border: 'none',
    outline: 'none',
    background: 'transparent',
    fontSize: 13,
    color: '#374151',
    width: 180,
  },

  btnPrimary: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    background: '#1D4ED8',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    padding: '7px 14px',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
  },
  btnSuccess: {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    background: '#ECFDF5',
    color: '#059669',
    border: '1px solid #6EE7B7',
    borderRadius: 7,
    padding: '6px 12px',
    fontSize: 12,
    fontWeight: 600,
    cursor: 'pointer',
  },
  btnDanger: {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    background: '#FEF2F2',
    color: '#DC2626',
    border: '1px solid #FECACA',
    borderRadius: 7,
    padding: '6px 12px',
    fontSize: 12,
    fontWeight: 600,
    cursor: 'pointer',
  },
  btnGhost: {
    background: 'transparent',
    border: '1px solid #EAECF0',
    borderRadius: 7,
    padding: '6px 12px',
    fontSize: 12,
    fontWeight: 500,
    cursor: 'pointer',
    color: '#374151',
  },

  // Table
  tableWrap: {
    background: '#fff',
    border: '1px solid #EAECF0',
    borderRadius: 12,
    overflow: 'hidden',
  },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: {
    background: '#F9FAFB',
    color: '#6B7280',
    fontWeight: 600,
    fontSize: 11,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    padding: '10px 14px',
    borderBottom: '1px solid #EAECF0',
    textAlign: 'left',
    whiteSpace: 'nowrap',
  },
  td: {
    padding: '11px 14px',
    borderBottom: '1px solid #F1F5F9',
    verticalAlign: 'middle',
    color: '#374151',
  },

  // Avatar
  avatar: (seed) => {
    const colors = [
      '#EFF6FF|#2563EB',
      '#ECFDF5|#059669',
      '#FFF7ED|#EA580C',
      '#FAF5FF|#7C3AED',
      '#FFF1F2|#E11D48',
    ];
    const [bg, fg] = colors[seed % colors.length].split('|');
    return {
      width: 30,
      height: 30,
      borderRadius: 8,
      background: bg,
      color: fg,
      fontWeight: 700,
      fontSize: 11,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    };
  },

  // Chips
  chip: (v) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 22,
    padding: '2px 8px',
    borderRadius: 20,
    fontSize: 11,
    fontWeight: 700,
    background: v > 0 ? '#EFF6FF' : '#F3F4F6',
    color: v > 0 ? '#2563EB' : '#9CA3AF',
  }),
  balChip: (v) => ({
    fontWeight: 700,
    fontSize: 13,
    color: v > 0 ? '#DC2626' : v < 0 ? '#16A34A' : '#6B7280',
  }),

  // Modal
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(15,23,42,0.35)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 200,
    backdropFilter: 'blur(2px)',
  },
  modal: {
    background: '#fff',
    borderRadius: 14,
    width: '92%',
    maxWidth: 860,
    maxHeight: '88vh',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 20px 60px rgba(0,0,0,.12)',
    overflow: 'hidden',
  },
  modalHeader: {
    padding: '16px 20px',
    borderBottom: '1px solid #EAECF0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
  },
  modalBody: { padding: 20, overflowY: 'auto', flex: 1 },

  // Small modal
  smModal: {
    background: '#fff',
    borderRadius: 12,
    width: '94%',
    maxWidth: 460,
    boxShadow: '0 20px 60px rgba(0,0,0,.14)',
  },
  smModalHeader: {
    padding: '14px 18px',
    borderBottom: '1px solid #EAECF0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  smModalBody: { padding: '16px 18px' },
  smModalFooter: {
    padding: '12px 18px',
    borderTop: '1px solid #EAECF0',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 8,
    background: '#F9FAFB',
  },

  formRow: { display: 'flex', gap: 10, marginBottom: 12, flexWrap: 'wrap' },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    flex: 1,
    minWidth: 140,
  },
  label: {
    fontSize: 11,
    fontWeight: 600,
    color: '#374151',
    textTransform: 'uppercase',
    letterSpacing: '0.4px',
  },
  input: {
    border: '1px solid #D1D5DB',
    borderRadius: 7,
    padding: '8px 10px',
    fontSize: 13,
    outline: 'none',
    background: '#fff',
    color: '#0F172A',
    width: '100%',
    boxSizing: 'border-box',
  },
  select: {
    border: '1px solid #D1D5DB',
    borderRadius: 7,
    padding: '8px 10px',
    fontSize: 13,
    outline: 'none',
    background: '#fff',
    color: '#0F172A',
    width: '100%',
    boxSizing: 'border-box',
  },

  // Booking pill
  bookingPill: (active) => ({
    padding: '5px 12px',
    borderRadius: 20,
    fontSize: 12,
    fontWeight: 600,
    cursor: 'pointer',
    border: `1px solid ${active ? '#2563EB' : '#D1D5DB'}`,
    background: active ? '#EFF6FF' : '#fff',
    color: active ? '#2563EB' : '#6B7280',
    transition: 'all .15s',
  }),

  spinner: {
    width: 28,
    height: 28,
    border: '3px solid #E5E7EB',
    borderTop: '3px solid #2563EB',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  },
};

// ─── Loader ───────────────────────────────────────────────────────────────────
const Spinner = ({ full }) =>
  full ? (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
      }}>
      <div style={styles.spinner} />
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  ) : (
    <>
      <div
        style={{ ...styles.spinner, width: 22, height: 22, borderWidth: 2 }}
      />
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </>
  );

// ─── Main Component ───────────────────────────────────────────────────────────
export default function CustomerWalletReport() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchName, setSearchName] = useState('');
  const [searchMobile, setSearchMobile] = useState('');

  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedBookingId, setSelectedBookingId] = useState(null);
  const [bookingTransactions, setBookingTransactions] = useState([]);
  const [bookingLoading, setBookingLoading] = useState(false);

  const [paymentOpen, setPaymentOpen] = useState(false);
  const [modalType, setModalType] = useState('in');
  const [form, setForm] = useState({
    bookingId: '',
    amount: '',
    mode: '',
    remark: '',
  });

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await fetch(
        `${config.API_BASE_URL}/home/GetCutomerWallet/${company?.id}`,
        { headers: { Authorization: `Bearer ${token()}` } },
      );
      const result = await res.json();
      setData(result || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const filtered = data.filter((g) => {
    const name = `${g.firstName || ''} ${g.lastName || ''}`.toLowerCase();
    return (
      name.includes(searchName.toLowerCase()) &&
      `${g.mobile || ''}`.includes(searchMobile)
    );
  });

  const totalBalance = filtered.reduce((s, c) => s + (c.balanceAmount || 0), 0);
  const totalBookings = filtered.reduce(
    (s, c) => s + (c.totalBookings || 0),
    0,
  );

  const fetchBooking = async (id) => {
    setBookingLoading(true);
    setBookingTransactions([]);
    try {
      const res = await fetch(
        `${config.API_BASE_URL}/home/GetBookingDetails/${id}`,
        { headers: { Authorization: `Bearer ${token()}` } },
      );
      if (res.ok) {
        const r = await res.json();
        setBookingTransactions(Array.isArray(r) ? r : []);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setBookingLoading(false);
    }
  };

  const openPayment = (type) => {
    setModalType(type);
    setForm({
      bookingId: selectedBookingId || '',
      amount: '',
      mode: '',
      remark: '',
    });
    setPaymentOpen(true);
  };

  const submitPayment = async () => {
    const payload = {
      BookingId: parseInt(form.bookingId) || 0,
      Companyid: company?.id,
      Userid: selectedCustomer?.id || 0,
      PayMode: form.mode,
      type: modalType === 'in' ? 'CR' : 'DR',
      Remark: form.remark || '',
      Amount: parseFloat(form.amount) || 0,
    };
    try {
      const res = await fetch(
        `${config.API_BASE_URL}/home/Adjustuserpayments`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token()}`,
          },
          body: JSON.stringify(payload),
        },
      );
      if (res.ok) {
        toast.success(modalType === 'in' ? 'Amount added!' : 'Amount deducted!');
        setPaymentOpen(false);
        fetchData();
        if (selectedBookingId) fetchBooking(selectedBookingId);
      } else {
        toast.error((await res.text()) || 'Failed');
      }
    } catch (e) {
      toast.error('Something went wrong');
    }
  };

  const exportXLSX = () => {
    if (!filtered.length) return;
    const rows = filtered.map((g, i) => ({
      '#': i + 1,
      'First Name': g.firstName,
      'Last Name': g.lastName,
      Mobile: g.mobile,
      Email: g.email,
      City: g.city,
      Bookings: g.totalBookings,
      Amount: g.totalAmount,
      DR: g.totalDR,
      CR: g.totalCR,
      Balance: g.balanceAmount,
      'Booking IDs': g.bookingIds?.join(', ') || '-',
    }));
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Wallet');
    XLSX.writeFile(wb, 'Customer_Wallet_Report.xlsx');
  };

  if (loading) return <Spinner full />;

  return (
    <div style={styles.page}>
      {/* ── Top bar ── */}
      <div style={styles.topbar}>
        <div style={styles.topbarTitle}>
          <Icon d={icons.wallet} size={18} color='#2563EB' />
          Customer Wallet
          <span style={styles.topbarBadge}>Report</span>
        </div>
        <button style={styles.btnPrimary} onClick={exportXLSX}>
          <Icon d={icons.download} size={14} />
          Export Excel
        </button>
      </div>

      <div style={styles.content}>
        {/* ── Stats ── */}
        <div style={styles.statStrip}>
          <div style={styles.statCard}>
            <div style={styles.statIcon('#EFF6FF', '#2563EB')}>
              <Icon d={icons.users} size={16} />
            </div>
            <div>
              <div style={styles.statLabel}>Customers</div>
              <div style={styles.statValue}>{filtered.length}</div>
            </div>
          </div>

          <div style={styles.statCard}>
            <div style={styles.statIcon('#FEF2F2', '#DC2626')}>
              <Icon d={icons.wallet} size={16} />
            </div>
            <div>
              <div style={styles.statLabel}>Total Balance</div>
              <div
                style={{
                  ...styles.statValue,
                  color: totalBalance >= 0 ? '#DC2626' : '#16A34A',
                }}>
                ₹{totalBalance.toLocaleString('en-IN')}
              </div>
            </div>
          </div>

          <div style={styles.statCard}>
            <div style={styles.statIcon('#ECFDF5', '#059669')}>
              <Icon d={icons.eye} size={16} />
            </div>
            <div>
              <div style={styles.statLabel}>Total Bookings</div>
              <div style={styles.statValue}>{totalBookings}</div>
            </div>
          </div>
        </div>

        {/* ── Toolbar ── */}
        <div style={styles.toolbar}>
          <div style={styles.searchGroup}>
            <div style={styles.searchBox}>
              <Icon d={icons.search} size={14} color='#9CA3AF' />
              <input
                style={styles.searchInput}
                placeholder='Search name…'
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
              />
            </div>
            <div style={styles.searchBox}>
              <Icon d={icons.search} size={14} color='#9CA3AF' />
              <input
                style={styles.searchInput}
                placeholder='Mobile…'
                value={searchMobile}
                onChange={(e) => setSearchMobile(e.target.value)}
              />
            </div>
          </div>
          <span style={{ fontSize: 12, color: '#9CA3AF' }}>
            {filtered.length} of {data.length} customers
          </span>
        </div>

        {/* ── Table ── */}
        <div style={styles.tableWrap}>
          <table style={styles.table}>
            <thead>
              <tr>
                {[
                  '#',
                  'Customer',
                  'Mobile',
                  'City',
                  'Bookings',
                  'Amount',
                  'DR',
                  'CR',
                  'Balance',
                  '',
                ].map((h) => (
                  <th key={h} style={styles.th}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((g, i) => {
                const initials =
                  `${(g.firstName || '?')[0]}${(g.lastName || '?')[0]}`.toUpperCase();
                return (
                  <tr
                    key={i}
                    style={{ background: i % 2 === 1 ? '#FAFBFC' : '#fff' }}>
                    <td
                      style={{
                        ...styles.td,
                        color: '#9CA3AF',
                        fontWeight: 600,
                        width: 36,
                      }}>
                      {i + 1}
                    </td>

                    <td style={styles.td}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 9,
                        }}>
                        <div style={styles.avatar(i)}>{initials}</div>
                        <div>
                          <div style={{ fontWeight: 600, color: '#111827' }}>
                            {g.firstName} {g.lastName}
                          </div>
                          <div style={{ fontSize: 11, color: '#9CA3AF' }}>
                            {g.email || '—'}
                          </div>
                        </div>
                      </div>
                    </td>

                    <td style={{ ...styles.td, fontWeight: 500 }}>
                      {g.mobile}
                    </td>
                    <td style={{ ...styles.td, color: '#6B7280' }}>
                      {g.city || '—'}
                    </td>

                    <td style={{ ...styles.td, textAlign: 'center' }}>
                      <span style={styles.chip(g.totalBookings)}>
                        {g.totalBookings || 0}
                      </span>
                    </td>

                    <td style={styles.td}>
                      ₹{(g.totalAmount || 0).toLocaleString('en-IN')}
                    </td>

                    <td
                      style={{
                        ...styles.td,
                        color: '#DC2626',
                        fontWeight: 500,
                      }}>
                      ₹{(g.totalDR || 0).toLocaleString('en-IN')}
                    </td>

                    <td
                      style={{
                        ...styles.td,
                        color: '#16A34A',
                        fontWeight: 500,
                      }}>
                      ₹{(g.totalCR || 0).toLocaleString('en-IN')}
                    </td>

                    <td style={styles.td}>
                      <span style={styles.balChip(g.balanceAmount)}>
                        ₹{(g.balanceAmount || 0).toLocaleString('en-IN')}
                      </span>
                    </td>

                    <td style={styles.td}>
                      <button
                        style={styles.btnGhost}
                        onClick={() => {
                          setSelectedCustomer(g);
                          setSelectedBookingId(null);
                          setBookingTransactions([]);
                        }}>
                        <Icon d={icons.eye} size={13} />
                      </button>
                    </td>
                  </tr>
                );
              })}

              {filtered.length === 0 && (
                <tr>
                  <td
                    colSpan={10}
                    style={{
                      ...styles.td,
                      textAlign: 'center',
                      color: '#9CA3AF',
                      padding: 40,
                    }}>
                    No customers found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ═══════════ Booking Modal ═══════════ */}
      {selectedCustomer && (
        <div
          style={styles.overlay}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setSelectedCustomer(null);
              setSelectedBookingId(null);
              setBookingTransactions([]);
            }
          }}>
          <div style={styles.modal}>
            <div style={styles.modalHeader}>
              <div>
                <div
                  style={{ fontWeight: 700, fontSize: 15, color: '#111827' }}>
                  {selectedCustomer.firstName} {selectedCustomer.lastName}
                </div>
                <div style={{ fontSize: 12, color: '#9CA3AF' }}>
                  Booking Transactions
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <button
                  style={styles.btnSuccess}
                  onClick={() => openPayment('in')}>
                  <Icon d={icons.plus} size={12} /> Add In (CR)
                </button>
                <button
                  style={styles.btnDanger}
                  onClick={() => openPayment('out')}>
                  <Icon d={icons.minus} size={12} /> Add Out (DR)
                </button>
                <button
                  style={styles.btnGhost}
                  onClick={() => {
                    setSelectedCustomer(null);
                    setSelectedBookingId(null);
                    setBookingTransactions([]);
                  }}>
                  <Icon d={icons.close} size={13} />
                </button>
              </div>
            </div>

            <div style={styles.modalBody}>
              {/* Booking pills */}
              <div style={{ marginBottom: 16 }}>
                <div
                  style={{
                    fontSize: 11,
                    color: '#9CA3AF',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    marginBottom: 8,
                  }}>
                  Select Booking
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                  {selectedCustomer?.bookingIds?.map((id) => (
                    <button
                      key={id}
                      style={styles.bookingPill(selectedBookingId === id)}
                      onClick={() => {
                        setSelectedBookingId(id);
                        fetchBooking(id);
                      }}>
                      #{id}
                    </button>
                  ))}
                </div>
              </div>

              {/* Transactions */}
              {selectedBookingId &&
                (bookingLoading ? (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      padding: 40,
                    }}>
                    <Spinner />
                  </div>
                ) : bookingTransactions.length > 0 ? (
                  <div style={{ ...styles.tableWrap, marginTop: 4 }}>
                    <table style={styles.table}>
                      <thead>
                        <tr>
                          {[
                            'Date',
                            'Mode',
                            'Remark',
                            'Amount',
                            'Check-in',
                            'Check-out',
                            'Days',
                          ].map((h) => (
                            <th key={h} style={styles.th}>
                              {h}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {bookingTransactions.map((t, idx) => (
                          <tr key={idx}>
                            <td style={styles.td}>
                              {new Date(t.tranjectiondate).toLocaleString('en-GB')}
                            </td>
                            <td style={styles.td}>
                              <span
                                style={{
                                  background:
                                    t.mode === 'Book' ? '#ECFDF5' : '#FFF7ED',
                                  color:
                                    t.mode === 'Book' ? '#059669' : '#EA580C',
                                  border: `1px solid ${t.mode === 'Book' ? '#6EE7B7' : '#FED7AA'}`,
                                  borderRadius: 6,
                                  padding: '2px 8px',
                                  fontSize: 11,
                                  fontWeight: 600,
                                }}>
                                {t.mode}
                              </span>
                            </td>
                            <td style={{ ...styles.td, color: '#6B7280' }}>
                              {t.remark || '—'}
                            </td>
                            <td
                              style={{
                                ...styles.td,
                                fontWeight: 700,
                                // Colour by DIRECTION, not the raw sign — DR and CR
                                // are both stored positive, so amount>0 painted every
                                // row red. CR (Add In / money received) = green +,
                                // DR (Add Out / charge) = red −.
                                color:
                                  (t.type || '').toUpperCase() === 'CR'
                                    ? '#16A34A'
                                    : '#DC2626',
                              }}>
                              {(t.type || '').toUpperCase() === 'CR' ? '+ ' : '− '}
                              ₹{t.amount}
                            </td>
                            <td style={styles.td}>{t.checkInTime || '—'}</td>
                            <td style={styles.td}>{t.checkOutTime || '—'}</td>
                            <td style={{ ...styles.td, textAlign: 'center' }}>
                              {t.totalDays || '—'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div
                    style={{
                      textAlign: 'center',
                      color: '#9CA3AF',
                      padding: '32px 0',
                      fontSize: 13,
                    }}>
                    No transactions for this booking
                  </div>
                ))}

              {!selectedBookingId && (
                <div
                  style={{
                    textAlign: 'center',
                    color: '#D1D5DB',
                    padding: '32px 0',
                    fontSize: 13,
                  }}>
                  Select a booking above to view transactions
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ═══════════ Payment Modal ═══════════ */}
      {paymentOpen && (
        <div
          style={styles.overlay}
          onClick={(e) => {
            if (e.target === e.currentTarget) setPaymentOpen(false);
          }}>
          <div style={styles.smModal}>
            <div style={styles.smModalHeader}>
              <div
                style={{
                  fontWeight: 700,
                  fontSize: 14,
                  color: modalType === 'in' ? '#059669' : '#DC2626',
                }}>
                {modalType === 'in' ? '+ Add In (CR)' : '− Add Out (DR)'}
              </div>
              <button
                style={styles.btnGhost}
                onClick={() => setPaymentOpen(false)}>
                <Icon d={icons.close} size={13} />
              </button>
            </div>

            <div style={styles.smModalBody}>
              <div style={styles.formRow}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Booking ID</label>
                  <input
                    style={{
                      ...styles.input,
                      background: '#F9FAFB',
                      color: '#9CA3AF',
                    }}
                    value={form.bookingId}
                    disabled
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Amount (₹)</label>
                  <input
                    style={styles.input}
                    type='number'
                    placeholder='Enter amount'
                    autoFocus
                    min='1'
                    value={form.amount}
                    onChange={(e) =>
                      setForm({ ...form, amount: e.target.value })
                    }
                  />
                </div>
              </div>

              <div style={styles.formRow}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Mode</label>
                  <select
                    style={styles.select}
                    value={form.mode}
                    onChange={(e) =>
                      setForm({ ...form, mode: e.target.value })
                    }>
                    <option value=''>Select…</option>
                    {['Cash', 'Card', 'UPI', 'Online', 'Book', 'Discount'].map(
                      (m) => (
                        <option key={m} value={m}>
                          {m}
                        </option>
                      ),
                    )}
                  </select>
                </div>
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Remark</label>
                <textarea
                  style={{ ...styles.input, height: 64, resize: 'vertical' }}
                  placeholder='Optional note…'
                  value={form.remark}
                  onChange={(e) => setForm({ ...form, remark: e.target.value })}
                />
              </div>
            </div>

            {(!form.amount || Number(form.amount) <= 0 || !form.mode) && (
              <div
                style={{
                  fontSize: 12,
                  color: '#DC2626',
                  padding: '0 4px 8px',
                }}>
                {!form.mode
                  ? 'Select a mode to enable Submit.'
                  : 'Enter an amount greater than 0 to enable Submit.'}
              </div>
            )}
            <div style={styles.smModalFooter}>
              <button
                style={styles.btnGhost}
                onClick={() => setPaymentOpen(false)}>
                Cancel
              </button>
              <button
                disabled={
                  !form.amount || Number(form.amount) <= 0 || !form.mode
                }
                onClick={submitPayment}
                style={{
                  ...(modalType === 'in'
                    ? styles.btnSuccess
                    : styles.btnDanger),
                  opacity:
                    !form.amount || Number(form.amount) <= 0 || !form.mode
                      ? 0.5
                      : 1,
                  fontSize: 13,
                  padding: '7px 18px',
                }}>
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
